import { useListIdentityMigrations } from '@urbanx/agx.support.client';
import { AgxTable, AgxTypography } from '@urbanx/agx.ui-components2';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { identityMigrationStatusLabels } from './identityMigrationStatusLabels';

function Cell({ children }: { children: string }) {
  return (
    <AgxTypography type="body_ui" size="small">
      {children}
    </AgxTypography>
  );
}

export default function IdentityMigrationHistory() {
  const { data: migrations = [], isPending, isError } = useListIdentityMigrations();

  if (isError)
    return (
      <AgxTypography type="form_error" role="alert">
        Unable to load recent identity migrations.
      </AgxTypography>
    );

  return (
    <AgxTable
      columns={['Started', 'Login change', 'Status', 'Operator']}
      rows={migrations.map((migration) => ({
        Started: <Cell>{dayjs(migration.startedUtc).format('DD/MM/YYYY h:mm A')}</Cell>,
        'Login change': <Cell>{`${migration.sourceEmail} → ${migration.destinationEmail}`}</Cell>,
        Status: <Cell>{identityMigrationStatusLabels[migration.status]}</Cell>,
        Operator: <Cell>{migration.operatorId}</Cell>,
      }))}
      showLoadingState={isPending}
      noDataLabel="No identity migrations have run yet"
      renderRowLink={(index, linkProps) => (
        <Link
          {...linkProps}
          to={migrations[index].operationId}
          aria-label={`${migrations[index].sourceEmail} to ${migrations[index].destinationEmail}`}
        />
      )}
    />
  );
}
